<script setup lang="ts">
import '../office-statusbar.css';

withDefaults(
  defineProps<{
    statusLabel?: string;
    live?: 'off' | 'polite' | 'assertive';
    /** The status bar of the shared document workspace, with its panel toggles. */
    workspace?: boolean;
    density?: 'comfortable' | 'compact';
    /**
     * How the bar fits a phone-wide window (600px and less): `all` keeps both
     * sections; `end` shows only the end section (panel toggles, zoom), spread
     * over the width, and drops the zoom slider below 360px — for a start
     * section of values that cannot shrink, like a workbook's selection
     * statistics.
     */
    narrow?: 'all' | 'end';
  }>(),
  { statusLabel: undefined, live: 'off', density: undefined, narrow: 'all' }
);
</script>

<template>
  <footer
    class="nx-office-statusbar"
    :data-office-view="workspace ? 'ribbon' : undefined"
    :data-density="density"
    :data-narrow="narrow === 'end' ? 'end' : undefined"
    role="status"
    :aria-label="statusLabel"
    :aria-live="live"
  >
    <div class="nx-office-statusbar__section">
      <slot />
    </div>
    <span class="nx-office-statusbar__spacer" aria-hidden="true" />
    <div v-if="$slots.end" class="nx-office-statusbar__section nx-office-statusbar__section--end">
      <slot name="end" />
    </div>
  </footer>
</template>
